import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CONFIG from "../../config/config";
import { Link } from "react-router-dom";
import { Mail, ExternalLink, MessageCircle, Calendar, Shield, FileText, Instagram, Users } from "lucide-react";

function Footer() {

  const { t } = useTranslation();
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="bg-darker-gold-300 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <h3 className="text-xl font-semibold text-white">eAteliers</h3>
            </div>
            <p className="text-gray-100 text-sm leading-relaxed">
              {t("footer.slogan")}
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">{t("footer.legal")}</h4>
            <div className="space-y-3">
              <Link
                to="/terms-of-service"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <FileText className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.terms_of_service")}</span>
              </Link>
              <Link
                to="/privacy-policy"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <Shield className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.privacy_policy")}</span>
              </Link>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">{t("footer.support")}</h4>
            <div className="space-y-3">
              <a
                href={`mailto:${CONFIG.CONTACT_INFO.EMAIL}`}
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <Mail className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.contact")}</span>
              </a>
              <a
                href={`mailto:${CONFIG.CONTACT_INFO.EMAIL}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <ExternalLink className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.support")}</span>
              </a>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-lg font-semibold text-white">{t("footer.quick_actions")}</h4>
            <div className="space-y-3">
              <a
                href="https://calendly.com/eateliers"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <Calendar className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.demo")}</span>
              </a>
              <a
                href={CONFIG.CONTACT_INFO.WHATSAPP}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <MessageCircle className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.feedback")}</span>
              </a>
              <a
                href={CONFIG.CONTACT_INFO.INSTAGRAM}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <Instagram className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>Instagram</span>
              </a>
              <a
                href="https://eateliers.com/referral.html"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-gray-100 hover:text-white transition-colors duration-200 group"
              >
                <Users className="w-4 h-4 group-hover:text-white transition-colors" />
                <span>{t("footer.referral_program")}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-100 text-sm">
              eAteliers &copy; 2019 - {currentYear} v{CONFIG.VERSION} {t("footer.copyright")}
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-100">
              <span>{t("footer.made_with_love")}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
